export interface IRPFResult {
  cuotaTotal: number;
  cuotaEstatal: number;
  cuotaAutonomica: number;
  cuotaMinimo: number;
  minimoPersonal: number;
}

export interface RegionRules {
  irpfTramosEstatales: { upTo: number; rate: number }[] | string;
  irpfTramosAutonomicos: { upTo: number; rate: number }[] | string;
}

export function calcIRPF(
  baseImponible: number,
  regionRules: RegionRules,
  minimoPersonal: number = 5550
): IRPFResult {
  function cuotaPorTramos(base: number, tramos: { upTo: number; rate: number }[]) {
    let remaining = base;
    let cuota = 0;
    let previousUpTo = 0;

    for (const tramo of tramos) {
      const trancheWidth = Math.min(remaining, tramo.upTo - previousUpTo);
      if (trancheWidth <= 0) break;

      cuota += trancheWidth * tramo.rate;
      remaining -= trancheWidth;
      previousUpTo = tramo.upTo;

      if (remaining <= 0) break;
    }

    return cuota;
  }

  const tramosEstatales = regionRules.irpfTramosEstatales as { upTo: number; rate: number }[];
  const tramosAutonomicos = regionRules.irpfTramosAutonomicos as { upTo: number; rate: number }[];

  const cuotaEstatalBase = cuotaPorTramos(baseImponible, tramosEstatales);
  const cuotaAutonomicaBase = cuotaPorTramos(baseImponible, tramosAutonomicos);

  const cuotaEstatalMin = cuotaPorTramos(minimoPersonal, tramosEstatales);
  const cuotaAutonomicaMin = cuotaPorTramos(minimoPersonal, tramosAutonomicos);

  const cuotaEstatal = Math.max(0, cuotaEstatalBase - cuotaEstatalMin);
  const cuotaAutonomica = Math.max(0, cuotaAutonomicaBase - cuotaAutonomicaMin);
  const cuotaTotal = cuotaEstatal + cuotaAutonomica;

  return {
    cuotaTotal,
    cuotaEstatal,
    cuotaAutonomica,
    cuotaMinimo: cuotaEstatalMin + cuotaAutonomicaMin,
    minimoPersonal,
  };
}
